import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="playlist.title" defaultMessage="Playlist title" />;
